import { gql } from '@apollo/client';

export const GET_GENERATION_TASKS = gql`
  query GenerationTasks {
    getAllGenerationTasks {
      id
      status
      planId
      input
      output
      createdAt
      updatedAt
    }
  }
`;

export const GET_GENERATION_TASKS_BY_PLAN_ID = gql`
  query GenerationTasks($planId: ID!) {
    getGenerationTasksByPlanId(planId: $planId) {
      id
      status
      planId
      input
      output
      createdAt
      updatedAt
    }
  }
`;
